import React, { Component } from 'react';
import { Date } from '../shared';

class BonusItem extends Component {
  render() {
    const { bonus } = this.props;

    return (
      <div className="list-group-item">
        <span className="ag-code">
          {bonus.agCode}
        </span>
        <span className="dat-range">
          <Date value={bonus.datVanaf} />
          &nbsp;t/m&nbsp;
          <Date value={bonus.datTot} />
        </span>
        <span className="percent pull-right">
          {bonus.percent} %
        </span>

      </div>
    );
  }
}

export default BonusItem;



// WEBPACK FOOTER //
// ./src/contacts/BonusItem.js